import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formContainer: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
      width: "100%",
    },
    sectionHeader: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    sectionSubheader: {
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.gray500,
    },
    OLPaper: {
      marginBottom: theme.spacing(12),
    },
    translationSection: {
      maxWidth: "100%",
      position: "relative",
      "&+&": {
        paddingTop: theme.spacing(12),
      },
      "&+&::after": {
        content: '""',
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
      },
    },
    conditionWrapper: {
      alignItems: "flex-start",
      display: "flex",
      justifyContent: "space-between",
    },
    clearIconWidth: {
      width: "36px",
      display: "flex",
      justifyContent: "end",
    },
    addTranslationBtn: {
      alignSelf: "start",
      color: theme.gray500,
      padding: theme.spacing(6, 6, 0, 0),
      marginTop: theme.spacing(6),
      fontWeight: 500,
    },
    conditionsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justinfyContent: "center",
      gap: theme.spacing(12),
      padding: theme.spacing(12, 0),
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(5),
      borderRadius: "140px",
      background: theme.primary50,
    },
    icon: {
      width: "24px",
      height: "24px",
      color: theme.primary500,
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    title: {
      color: theme.primary800,
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "29px",
      marginBottom: theme.spacing(4),
    },
    description: {
      color: theme.gray500,
      fontSize: "16px",
      lineHeight: "24px",
      textAlign: "center",
    },
    marginBottom: {
      marginBottom: theme.spacing(8),
    },
    fullWidth: {
      width: "100% !important",
      maxWidth: "100% !important",
    },
    zeroPadding: {
      padding: "0 !important",
    },
    boldText: {
      fontWeight: 500,
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": {
        marginTop: 0,
      },
    },
    andOperator: {
      color: theme.gray500,
      margin: theme.spacing(8, 0),
    },
    anniversaryInfo: {
      color: theme.gray500,
      fontSize: 14,
      fontWeight: 400,
      margin: theme.spacing(6, 0),
    },
    dateWrapper: {
      display: "flex",
      alignItems: "center",
      marginTop: theme.spacing(12),
      gap: theme.spacing(12),
    },
    input: {
      marginTop: theme.spacing(12),
      width: "100%",
    },
  }),
);
